'use client'

import Image from 'next/image'
import { useState } from 'react'
import { useTranslations } from 'next-intl'

import type { FC } from 'react'
import type { ICompetenciesData, IFetchedDataRoot } from '@/types'

const Competencies: FC<IFetchedDataRoot<ICompetenciesData>> = ({ results }) => {
  const t = useTranslations()
  const sortedResults = results.sort((a, b) => a.id - b.id)
  const [activeTab, setActiveTab] = useState<ICompetenciesData>(sortedResults[0])

  const buttonHandler = (val: ICompetenciesData) => {
    setActiveTab(val)
  }

  const scrollToContact = () => {
    const contactElement = document.getElementById('contact')
    if (contactElement) {
      const yOffset = contactElement.getBoundingClientRect().top + window.scrollY - 70
      window.scrollTo({ top: yOffset, behavior: 'smooth' })
    }
  }

  return (
    <section className="container mx-auto px-4 pt-[30px] md:pt-[80px]" id="competencies">
      <h2 className="mb-5 md:mb-10">{t('CompetencySection.title')}</h2>
      <div>
        <div className="flex translate-y-[1px] flex-row justify-between overflow-x-auto font-medium">
          {sortedResults.map((data) => (
            <button
              aria-label={data.title}
              key={data.id + data.title}
              className={`rounded-xl rounded-b-none border border-b-0 px-4 pb-2 pt-2 text-xs duration-200 sm:px-5 sm:pt-4 md:text-base ${
                activeTab.id === data.id
                  ? 'border-[#D9D9D9] bg-white'
                  : 'border-transparent text-[#737A81] hover:bg-[#737A81]/10'
              }`}
              onClick={() => buttonHandler(data)}
            >
              {data.title}
            </button>
          ))}
        </div>

        <div
          className={`grid grid-cols-2 gap-5 rounded-xl border border-[#D9D9D9] bg-white p-4 duration-200 sm:gap-10 ${
            activeTab.id === 1 ? 'rounded-tl-none' : ''
          } ${activeTab.id === 5 ? 'rounded-tr-none' : ''}`}
        >
          <article className="col-span-2 flex flex-col p-4 md:col-span-1 md:p-8">
            <h3 className="mb-4">{activeTab.title}</h3>
            <div
              className="apply-def-styles flex-1 text-secondary-dark marker:text-primary"
              dangerouslySetInnerHTML={{ __html: activeTab.description }}
            />
            <button
              className="btn-primary-outlined w-fit"
              aria-label={t('Buttons.More')}
              onClick={scrollToContact}
            >
              {t('Buttons.More')}
            </button>
          </article>
          <div className="col-span-2 h-full max-h-[387px] w-full max-w-[536px] overflow-hidden rounded-xl md:col-span-1">
            <Image
              src={activeTab.image}
              alt={activeTab.title}
              width={536}
              height={387}
              className=" h-full w-full overflow-hidden object-cover "
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default Competencies
